import IconButton from '../Kizen/IconButton';
import Icon from '../Kizen/Icon';
import { gray } from '@kizen/kds/Colors';

const closeButtonColor = {
  default: gray['gray-600'],
  hover: gray['gray-800'],
};

const CloseButton = (props) => (
  <IconButton
    sizing="mobile"
    data-dismiss="modal"
    color={closeButtonColor}
    {...props}
  >
    <Icon icon="close-cross" />
  </IconButton>
);

export default CloseButton;
